"use client";

import { useState } from "react";
import Image from "next/image";

/** Cover photo that disappears if it fails to load, so the card's gradient shows instead of a broken-image icon. */
export function CoverPhoto({ src, plain = false, fit = "contain" }: { src: string; plain?: boolean; fit?: "contain" | "cover" }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <>
      <Image
        src={src}
        alt=""
        fill
        sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        className={`${fit === "cover" ? "object-cover" : "object-contain"} transition-transform duration-700 group-hover/card:scale-105`}
        onError={() => setFailed(true)}
      />
      {!plain && <div className="absolute inset-0 bg-brand-900/20" />}
    </>
  );
}
